import {
  FormControl,
  FormHelperText,
  IconButton,
  InputAdornment,
  InputLabel,
  InputProps,
  OutlinedInput
} from '@mui/material'
import { useState } from 'react'
import { VisibilityOffOutlined, VisibilityOutlined } from '@mui/icons-material'

/**
 * Props for the password input component.
 */
interface IInputPasswordProps extends InputProps {
  /** The label for the input field */
  label: string
  /** The variant of the input field (optional) */
  variant: 'outlined' | 'standard' | 'filled' | undefined
  /** Additional helper text to display below the input field (optional) */
  helperText?: string
}

/**
 * Password input component with visibility toggle
 *
 * @param {IInputPasswordProps} props - The properties for the input component.
 * @returns {JSX.Element} Returns a password input component.
 */
const InputPassword = (props: IInputPasswordProps) => {
  const [showPassword, setShowPassword] = useState(false)
  return (
    <FormControl sx={{ width: '100%' }} variant={props.variant}>
      <InputLabel htmlFor='standard-adornment-password'>
        {props.label}
      </InputLabel>
      <OutlinedInput
        {...props}
        id='standard-adornment-password'
        type={showPassword ? 'text' : 'password'}
        endAdornment={
          <InputAdornment position='end'>
            <IconButton
              aria-label={
                showPassword ? 'hide the password' : 'display the password'
              }
              onClick={() => setShowPassword(!showPassword)}
            >
              {showPassword ? (
                <VisibilityOffOutlined />
              ) : (
                <VisibilityOutlined />
              )}
            </IconButton>
          </InputAdornment>
        }
      />
      {props.helperText && (
        <FormHelperText className='Mui-error'>
          {props.helperText}
        </FormHelperText>
      )}
    </FormControl>
  )
}

export default InputPassword
